import angular from 'angular'
import './all_sales.service'

angular.module('admin.all_sales', ['admin.all_sales.service'])

require('./tabs/transactions/transactions.controller')
require('./tabs/accounting/accounting.controller')
require('./tabs/user_analytics/user_analytics.controller')

angular
  .module('admin.all_sales')
  .controller('AllSalesAdminCtrl', AllSalesAdminCtrl)

/** @ngInject */
function AllSalesAdminCtrl(AllSalesService) {
  var vm = this

  // Shared state
  vm.channels = []

  // Init shared data
  AllSalesService.getChannels().then(function (chans) {
    vm.channels = chans
  })

  // Helper for amounts (used in transactions)
  vm.parseFloat = function (val) {
    return parseFloat(val) || 0
  }
}
